import { createContext, useContext, useState } from 'react';
import { CopyCallModalComponentType } from '../copy-call/components/copy-call-modal';
import { RequestAssistanceModalComponentType } from '../request-assistance/components/request-assistance-modal';
import { ClearEventModalComponentType } from './clear-event-modal';
import { UpdateDispositionModalComponentType } from './update-disposition-modal';

export type EventPanelModal =
    | {
          type: 'UPDATE_DISPOSITION';
          props: Omit<
              React.ComponentProps<UpdateDispositionModalComponentType>,
              'setActiveEventPanelTab'
          >;
      }
    | {
          type: 'CLEAR_EVENT';
          props: Omit<
              React.ComponentProps<ClearEventModalComponentType>,
              // We can omit this from the interface because we pass this in when the modal
              // is rendered
              'setActiveEventPanelTab'
          >;
      }
    | {
          type: 'REQUEST_ASSISTANCE';
          props: React.ComponentProps<RequestAssistanceModalComponentType>;
      }
    | {
          type: 'COPY_CALL';
          props: React.ComponentProps<CopyCallModalComponentType>;
      };

const EventPanelModalReadContext = createContext<undefined | EventPanelModal>(undefined);
const EventPanelModalWriteContext = createContext<
    undefined | ((modal: undefined | EventPanelModal) => void)
>(undefined);

export function EventPanelModalProvider(props: { children: React.ReactNode }) {
    const [eventPanelModal, setEventPanelModal] = useState<undefined | EventPanelModal>(undefined);
    return (
        <EventPanelModalReadContext.Provider value={eventPanelModal}>
            <EventPanelModalWriteContext.Provider value={setEventPanelModal}>
                {props.children}
            </EventPanelModalWriteContext.Provider>
        </EventPanelModalReadContext.Provider>
    );
}

export function useSetEventPanelModal() {
    const value = useContext(EventPanelModalWriteContext);
    if (!value) throw new Error('Unexpectedly did not find value on EventPanelModalWriteContext');
    return value;
}

export function useEventPanelModal() {
    return useContext(EventPanelModalReadContext);
}
